import axios from "axios";

// Create an axios instance with default config
export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL_V1 || "http://localhost:8080/api/v1",
  headers: {
    "Content-Type": "application/json",
  },
});


// Add a response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle unauthorized errors (401)
    if (error.response && error.response.status === 401) {
      // Clear local storage and redirect to login
      localStorage.removeItem("auth_token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);
